<template>
  <tr>
    <th></th>
    <th></th>
    <th></th>
    <th></th>
    <th colspan="2" class="text-center">Total Net Price</th>
    <td class="text-center">
      <div>
        {{ netPrice + " ฿" }}
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  name: "totalNetPrice",
  props: ["netPrice"],
};
</script>

<style>
</style>